import { render, staticRenderFns } from "./ChartShimer.vue?vue&type=template&id=36935e4a&"
import script from "./ChartShimer.vue?vue&type=script&lang=js&"
export * from "./ChartShimer.vue?vue&type=script&lang=js&"
import style0 from "./ChartShimer.vue?vue&type=style&index=0&id=36935e4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports